import React from "react";
import SideMenu from "../components/SideMenu";
import TemplateHeader from "../components/template/TemplateHeader";

const TemplateManager = () => {
  return (
    <div className="container-fluid">
      <div className="row"></div>
      <div className="row">
        <div className="col-md-2">
          <SideMenu />
        </div>
        <div className="col-md-10">
          <p>Template Header</p>
          <TemplateHeader />
        </div>
      </div>
    </div>
  );
};

export default TemplateManager;
